<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="大型号">
            <el-select v-model="searchForm.bigModel" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in bigModelList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品类细分">
            <el-select v-model="searchForm.category" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in categoryList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="isShowAdd = true">新增</el-button>
        <el-button type="primary" size="mini" @click="importExcel">导入</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="category" label="品类细分"> </el-table-column>
        <el-table-column prop="bigModel" label="大型号"> </el-table-column>
        <el-table-column prop="saleAmountDiff" label="销售额差异(万)"> </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="200"> </el-table-column>
        <el-table-column prop="updatedBy" label="更新人"> </el-table-column>
        <el-table-column prop="updatedDate" label="更新时间"> </el-table-column>
        <el-table-column prop="" label="编辑" fixed="right" width="100" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
            <el-button type="text" size="mini" @click="delRow(row)" style="color: red">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <add-dialog :visible.sync="isShowAdd" v-if="isShowAdd" @success="onSearch" />
    <edit-dialog :visible.sync="isShowEdit" v-if="isShowEdit" :rowData="rowData" @success="onSearch" />
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from "@/utils/tableMixin";
import axios from "@/utils/axiosInstance";
import { downloadFile } from "@/utils";
import addDialog from "./add.vue";
import editDialog from "./edit.vue";
import moment from "moment";
export default {
  name: "keyProductConfiguration",
  mixins: [tableMixin, pagePathMixin],
  components: { addDialog, editDialog },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: "productCategoryBigModelConfig",
      columnData: [],
      loading: false,
      searchForm: {
        bigModel: "",
        category: "",
        billStatusDesc: "",
        sendStatus: "",
      },
      exportData: {},
      searchCollapse: false,
      isShowAdd: false,
      isShowEdit: false,
      selectionVal: [],
      queryCriteria: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      bigModelList: [],
      categoryList: [],
      billStatusDescList: [],
      sendStatusList: [],
      priceRatio: "",
    };
  },
  computed: {},
  methods: {
    onSearch() {
      // let platCodeType = this.searchForm.platCode && this.searchForm.platCode.split(" ").length > 1000
      // if(platCodeType) {
      //   this.$message.error('已超过1000条，请核对！')
      //   return
      // }
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "bigModel", //大型号
          val: [this.searchForm.bigModel ? this.searchForm.bigModel : ""],
          op: "in",
        },
        {
          attributeName: "category", //品类细分
          val: [this.searchForm.category ? this.searchForm.category : ""],
          op: "in",
        },
      ];
      this.init();
      this.getbigModelList();
      this.getcategoryList();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            if (!type) {
              this.tableReload = false;
              this.$nextTick((_) => {
                this.tableReload = true;
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    handleSelectionChange(val) {
      this.selectionVal = val;
    },

    reset() {
      if (this.$refs["table"]) {
        this.$refs["table"].clearSort(); //切换清除排序
      }
      // this.filterPropertyName = [];
      this.searchForm = {
        bigModel: "",
        category: "",
        billStatusDesc: "",
        sendStatus: "",
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    
    edit(row) {
      this.rowData = {...row}
      this.isShowEdit = true
    },

    async delRow(row) {
      let status = await this.$confirm("是否确认删除该条数据？", "提示", { type: "warning" });
      if (status !== "confirm") return;
      let res = await this.$q.product.categoryBigModelConfigDel({ fragment: [row.dataId] });
      if (res.success) {
        this.$message.success("删除成功");
      } else {
        this.$message.fail("删除失败");
      }
      this.onSearch();
    },

    getbigModelList() {
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "bigModel";
      data.hasCount = "Y";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.bigModelList = data;
      });
    },
    getcategoryList() {
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "category";
      data.hasCount = "Y";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.categoryList = data;
      });
    },
    //导入
    importExcel() {
      this.openSubPage({
        //核心语句
        path: "/keyProductConfigurationImport",
        // name: 'importexcelbyspu',   //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          // fileType: '18',
          fileName: "重点品型号配置导入.xlsx",
          appCode: "ec-pc-new",
          reportName: "productCategoryBigModelConfigImport",
        },
      });
    },
    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        appCode: "ec-pc-new",
        paramMap: {
          ...this.searchFormData,
        },
        reportName: "productCategoryBigModelConfig",
      };
      this.$q.orderDate.importExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
        } else {
          this.$message.error(res.message);
        }
      }).finally(_=>{
        loading.close()
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
// >>> .el-form-item {
//   margin-bottom: 10px;
// }
</style>
